var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 18,
    viewBox: "0 0 26 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2506 11.9999C20.6646 12.0002 21.0006 12.3359 21.0006 12.7499C21.0005 15.7439 17.3659 17.9998 13.0006 17.9999C8.63508 17.9999 5.00069 15.744 5.00059 12.7499C5.00059 12.3357 5.33638 11.9999 5.75059 11.9999C6.1646 12.0002 6.50059 12.3359 6.50059 12.7499C6.50071 14.7263 9.35811 16.4999 13.0006 16.4999C16.6429 16.4998 19.5005 14.7262 19.5006 12.7499L19.5074 12.6484C19.5571 12.2823 19.8709 11.9999 20.2506 11.9999ZM23.2506 9.99992C23.6301 10.0001 23.9441 10.2824 23.9938 10.6484L24.0006 10.7499V17.2499C24.0005 17.6639 23.6646 17.9997 23.2506 17.9999C22.8709 17.9999 22.5571 17.7176 22.5074 17.3515L22.5006 17.2499V10.7499C22.5006 10.3357 22.8364 9.99992 23.2506 9.99992ZM12.6647 0.329025C12.8755 0.223751 13.1237 0.223891 13.3346 0.329025L25.3356 6.32902C25.8879 6.60553 25.8879 7.39434 25.3356 7.67082L13.3346 13.6708C13.1237 13.7759 12.8754 13.7761 12.6647 13.6708L0.664657 7.67082C0.112369 7.39434 0.112413 6.60555 0.664657 6.32902L12.6647 0.329025ZM2.6754 6.99992L12.9996 12.1611L23.3229 6.99992L12.9996 1.83781L2.6754 6.99992Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/Icon1.f725f19ae09b90187efed402dd54bdcd.svg";
export { ForwardRef as ReactComponent };